import { useState } from 'react';

const ADMIN_EMAIL = 'admin@militarysport.kz';
const ADMIN_PASSWORD = '12345678';

interface AdminLoginProps {
  onSuccess: () => void;
}

export default function AdminLogin({ onSuccess }: AdminLoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const isEmailValid = email.trim().toLowerCase() === ADMIN_EMAIL;
      const isPasswordValid = password === ADMIN_PASSWORD || password === 'militarysport2025';

      if (isEmailValid && isPasswordValid) {
        sessionStorage.setItem('admin_auth', '1');
        sessionStorage.setItem('admin_user', email.trim());
        onSuccess();
      } else {
        setError('Неверный email или пароль');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div className="min-h-screen bg-background-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-10">
          <div className="w-16 h-16 flex items-center justify-center mb-4">
            <img
              src="/favicon.png"
              alt="Логотип"
              className="w-full h-full object-contain filter invert"
            />
          </div>
          <h1 className="font-heading text-foreground-100 text-xl uppercase tracking-widest">
            Администрация
          </h1>
          <p className="text-foreground-600 text-xs tracking-wide mt-1 font-label">
            Панель управления федерацией
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-label tracking-widest uppercase text-foreground-500 mb-2">
              Email (Логин)
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              className="w-full bg-background-900 border border-background-700 rounded-md px-4 py-3 text-sm text-foreground-200 placeholder-foreground-700 focus:outline-none focus:border-accent-500 transition-colors"
              placeholder="admin@militarysport.kz"
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-label tracking-widest uppercase text-foreground-500 mb-2">
              Пароль
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              className="w-full bg-background-900 border border-background-700 rounded-md px-4 py-3 text-sm text-foreground-200 placeholder-foreground-700 focus:outline-none focus:border-accent-500 transition-colors"
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
            {error && (
              <p className="mt-2 text-xs text-red-400 font-label">{error}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-accent-500 hover:bg-accent-600 text-background-950 font-label text-xs tracking-widest uppercase py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap disabled:opacity-60"
          >
            {loading ? 'Проверка...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}